module.exports = __webpack_public_path__ + "media/images/img_ftr-logo-7e2e7efed278153555ac32804fad99f2.jpeg";